import styled from 'styled-components';

//TABS

export const Container = styled.div`
  .categories-nav {
    border-bottom: 1px solid var(--color-light-pink);

    @media screen and (min-width: 1186px) {
      display: flex;
      flex: auto;
      flex-wrap: nowrap;
      overflow-x: auto;
      overflow-y: hidden;
      white-space: nowrap;
      padding-top: 6px;
      cursor: grab;
      justify-content: center;

      ::-webkit-scrollbar {
        display: none;
      }

      ul {
        display: flex;
        padding: 0 20px;
        gap: 80px;

        ::-webkit-scrollbar {
          display: none;
        }
      }

      li {
        list-style: none;
      }

      li:last-child {
        a {
          margin-right: 0;
        }
      }

      a {
        padding-bottom: 26px;
        display: block;
        text-decoration: none;
        position: relative;
        margin-left: 10px;
        margin-right: 10px;

        &::before {
          content: '';
          background: var(--primary-color-dark);
          width: 100%;
          opacity: 0;
          height: 7px;
          display: block;
          border-radius: 7px;
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
          transition: all 0.3s ease;
        }

        &.active {
          &::before {
            opacity: 1;
          }
          span {
            color: var(--primary-color-dark);
            font-family: 'Inter Bold';
            font-size: var(--font-larger);
          }
        }

        span {
          color: var(--primary-color);
          font-family: 'Inter Bold';
          font-size: var(--font-larger);
        }
      }
    }

    @media screen and (max-width: 1185px) {
      display: none;
    }
  }
`;
